/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignatureTypeWithRelations } from '../../models/signature-type-with-relations';

export interface GetSignatureTypesList$Params {
}

export function getSignatureTypesList(http: HttpClient, rootUrl: string, params?: GetSignatureTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SignatureTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getSignatureTypesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SignatureTypeWithRelations>>;
    })
  );
}

getSignatureTypesList.PATH = '/signature-types';
